import {FeedView} from './FeedView';

export const FeedPage = ({darkMode}) => {
  return <FeedView darkMode={darkMode}/>;
};
